import i18n from "../../../i18n";

export enum MAINTENANCE_COL_IDS {
  MOBILE = 'MOBILE',
  STATUS = 'STATUS',
  TYPE = 'TYPE',
  ODOMETER = 'ODOMETER',
  WORKING_HOURS = 'WORKING_HOURS',
  NEXT_CHECK = 'NEXT_CHECK'
}

export const MAINTENANCE_COLUMNS = {
  [MAINTENANCE_COL_IDS.MOBILE]: {
    id: MAINTENANCE_COL_IDS.MOBILE,
    label: i18n.t('Mobile'),
    path: 'globalid',
    width: '250px'
  },
  [MAINTENANCE_COL_IDS.STATUS]: {
    id: MAINTENANCE_COL_IDS.STATUS,
    label: i18n.t('Status'),
    path: 'warning',
    width: '250px'
  },
  [MAINTENANCE_COL_IDS.TYPE]: {
    id: MAINTENANCE_COL_IDS.TYPE,
    label: i18n.t('Type'),
    path: 'type'
  },
  [MAINTENANCE_COL_IDS.ODOMETER]: {
    id: MAINTENANCE_COL_IDS.ODOMETER,
    label: i18n.t('Odometer'),
    path: 'odometer'
  },
  [MAINTENANCE_COL_IDS.WORKING_HOURS]: {
    id: MAINTENANCE_COL_IDS.WORKING_HOURS,
    label: i18n.t('Working hours'),
    path: 'working_hours'
  },
  [MAINTENANCE_COL_IDS.NEXT_CHECK]: {
    id: MAINTENANCE_COL_IDS.NEXT_CHECK,
    label: i18n.t('Next check'),
    path: 'next_check'
  }
}
